import { FC, useState } from 'react';
import styles from './index.module.scss';
import { DemandArea } from '../../../../lib/types/endUser';
import { ReactComponent as EviLeftFrame } from '../../../../assets/icons/evi-small-house-left-frame.svg';
import { ReactComponent as EviRightFrame } from '../../../../assets/icons/evi-small-house-right-frame.svg';
import { useIsEviTenant } from '../../../../lib/hooks/endUserHooks/useIsEviTenant';
import cn from 'classnames';

type Props = {
  currentDemandArea: DemandArea;
  areaColor: string;
  areaId: number;
  onAreaClick: () => void;
  isTop?: boolean;
  index?: number;
};

export const SmallHouseItem: FC<Props> = ({
  currentDemandArea,
  areaColor,
  areaId,
  onAreaClick,
  isTop,
  index,
}) => {
  const [isHovered, setIsHovered] = useState(false);
  const isEviTenant = useIsEviTenant();

  const getCategoryCardStyle = (isHovered: boolean, demandAreaColor: string) =>
    isHovered ? `color-mix(in srgb, ${demandAreaColor}, #FFFFFF 73%)` : '#fff';
  const handleMouseEnter = () => setIsHovered(true);
  const handleMouseLeave = () => setIsHovered(false);

  const isLeft = index === 0;

  if (isEviTenant && isTop) {
    return (
      <div
        role="presentation"
        onClick={onAreaClick}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        className={styles.smallHouseSquare}
      >
        {isLeft ? (
          <EviLeftFrame
            className={styles.frameIcon}
            fill={
              currentDemandArea.id === areaId
                ? areaColor
                : getCategoryCardStyle(isHovered, areaColor)
            }
          />
        ) : (
          <EviRightFrame
            className={styles.frameIcon}
            fill={
              currentDemandArea.id === areaId
                ? areaColor
                : getCategoryCardStyle(isHovered, areaColor)
            }
          />
        )}
      </div>
    );
  }

  return (
    <div
      role="presentation"
      onClick={onAreaClick}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      className={cn(styles.smallHouseSquare, isEviTenant && styles.eviBottomSquare)}
      style={{
        backgroundColor:
          currentDemandArea.id === areaId
            ? areaColor
            : getCategoryCardStyle(isHovered, areaColor),
      }}
    ></div>
  );
};
